import { render, staticRenderFns } from "./DevelopmentTools.vue?vue&type=template&id=189b7972&scoped=true"
import script from "./DevelopmentTools.vue?vue&type=script&lang=js"
export * from "./DevelopmentTools.vue?vue&type=script&lang=js"
import style0 from "./DevelopmentTools.vue?vue&type=style&index=0&id=189b7972&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "189b7972",
  null
  
)

export default component.exports